import { useMemo, useState } from "react";

import type { ILegendItem } from "app/components/React/Legends/legendsTypes";
import type { ICategoryComparison } from "app/pages/industry-analysis/categories-context";

export const useLegendItems = (data: Record<string, any> | null, categories: ICategoryComparison[]) => {
    const [hiddenIds, setHiddenIds] = useState<Set<string>>(new Set());

    const legendItems = useMemo<ILegendItem[]>(() => {
        if (!data) {
            return [];
        }

        return Object.keys(data).map((categoryId) => {
            const category = categories.find(({ category }) => category.id === categoryId);
            return {
                id: categoryId,
                name: category?.category.text || categoryId,
                color: category?.color || null,
                visible: !hiddenIds.has(categoryId),
            };
        });
    }, [data, categories, hiddenIds]);

    const toggleItem = (itemId: string) => {
        setHiddenIds((prev) => {
            const next = new Set(prev);
            if (next.has(itemId)) {
                next.delete(itemId);
            } else {
                next.add(itemId);
            }
            return next;
        });
    };

    return { legendItems, toggleItem };
};
